// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "VideosSection-module--wrapper--lXkNW";
export var videoWrapper = "VideosSection-module--videoWrapper--i-qS0";
export var backgroundDecorator = "VideosSection-module--backgroundDecorator--zHvxm";